module.exports = {"pageTitleText":"Service Setting"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/appProfileSetting.json
// module id = WMxi
// module chunks = 3